import { render, staticRenderFns } from "./record.vue?vue&type=template&id=f70288ac&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style1 from "./record.vue?vue&type=style&index=1&id=f70288ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70288ac",
  null
  
)

export default component.exports